import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';
import { AuthMinimalLayout } from 'layout/MinimalLayout';

// render pages
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const ResetPassword = Loadable(
    lazy(() => import('pages/authentication/ResetPassword')),
);

// ==============================|| AUTH ROUTING ||============================== //
const LoginRoutes: RouteObject = {
    path: '/',
    element: <AuthMinimalLayout />,
    children: [
        {
            path: 'login',
            element: <AuthLogin />,
        },
        {
            path: 'reset-password',
            element: <ResetPassword />,
        },
    ],
};

export default LoginRoutes;
